import { isProd } from 'config/config';
import swal from 'sweetalert';
import { getShippingBilling, postShippingBilling, validateAddress, fetchCartSummary, API } from 'helpers/api';

import Vue from 'vue/dist/vue';
import VueMask from 'v-mask';

Vue.use(VueMask);

const shippingEl = document.getElementById('shipping-billing');

if (shippingEl) {
    new Vue({
        el: '#shipping-billing',
        data: {
            isLoading: true,
            HasError: false,
            res: null,
            fetchCartRes: null,
            fields: {
                shipVia: {
                    default: {
                        value: '',
                        filled: true,
                    },
                    custom: {
                        value: '',
                        filled: true,
                    },
                },
                shipType: '',
                customShippingAddress: {
                    Name: {
                        value: '',
                        filled: true,
                    },
                    StreetLine1: {
                        value: '',
                        filled: true,
                    },
                    StreetLine2: {
                        value: '',
                    },
                    City: {
                        value: '',
                        filled: true,
                    },
                    State: {
                        value: '',
                        filled: true,
                    },
                    Zip: {
                        value: '',
                        filled: true,
                    },
                    Phone: {
                        value: '',
                        filled: true,
                    },
                },
                customBillingAddress: {
                    Name: {
                        value: '',
                        filled: true,
                    },
                    StreetLine1: {
                        value: '',
                        filled: true,
                    },
                    StreetLine2: {
                        value: '',
                    },
                    City: {
                        value: '',
                        filled: true,
                    },
                    State: {
                        value: '',
                        filled: true,
                    },
                    Zip: {
                        value: '',
                        filled: true,
                    },
                },
                billingType: '',
                creditCard: {
                    CardName: {
                        value: '',
                        filled: true,
                    },
                    CardNumber: {
                        value: '',
                        filled: true,
                    },
                    CardExpDate: {
                        value: '',
                        filled: true,
                    },
                    CardCVV: {
                        value: '',
                        filled: true,
                    },
                },
            },
            shipAddressIsDefault: null,
            billingAddressIsDefault: true,
            hasMultiplePaymentTypes: null,
            shipVia: {
                default: null,
                custom: null,
                showCustomShipVias: false,
            },
            addressValidation: {
                suggestedAddress: null,
                addressSelection: 'suggested',
                showSuggestion: false,
                showPOBoxError: false,
                showFailureToValidate: false,
            },
            submissionError: {
                exists: false,
                text: null,
            },
            IsProhibitedState: false,
        },
        computed: {
            isProd() {
                return isProd;
            },
            postValues() {
                const post = {};

                const addItemsToPost = function (fieldsObj, name) {
                    if (name) {
                        post[name] = {};
                        Object.keys(fieldsObj).forEach((key) => {
                            post[name][key] = fieldsObj[key].value;
                        });
                    } else {
                        Object.keys(fieldsObj).forEach((key) => {
                            post[key] = fieldsObj[key].value;
                        });
                    }
                };

                // add ship via
                if (this.shipAddressIsDefault) {
                    post.ShipVia = this.shipVia.default.find((option) => {
                        return option.Description == this.fields.shipVia.default.value;
                    }).Id;
                } else {
                    post.ShipVia = this.shipVia.custom.find((option) => {
                        return option.Description == this.fields.shipVia.custom.value;
                    }).Id;
                }

                // add shipping address
                if (this.shipAddressIsDefault) {
                    post.ShippingAddress = {};
                    post.ShippingAddress.Id = null;
                } else {
                    addItemsToPost(this.fields.customShippingAddress, 'ShippingAddress');
                    post.ShippingAddress.Id = 0;
                }

                if (this.fields.billingType === 'CreditCard') {
                    // add credit card info
                    addItemsToPost(this.fields.creditCard);
                    post.CardNumber = post.CardNumber.replace(/\s+/g, '');
                    delete post.CardExpDate; // post requires separate month and year properties
                    post.CardExpMonth = this.fields.creditCard.CardExpDate.value.slice(0, 2);
                    post.CardExpYear = '20' + this.fields.creditCard.CardExpDate.value.slice(3, 5);
                    post.TermsCode = 'CreditCard';

                    // add credit card billing addresses
                    if (this.billingAddressIsDefault) {
                        post.ShippingAddressIsBillingAddress = true;
                    } else {
                        addItemsToPost(this.fields.customBillingAddress, 'BillingAddress');
                        post.BillingAddress.Id = 0;
                        post.ShippingAddressIsBillingAddress = false;
                    }
                }

                return post;
            },
            addressValidationValues() {
                // returns values from shipping address fields in proper formatting to be used with validateAddress function
                const address = {};

                Object.keys(this.fields.customShippingAddress).forEach((item) => {
                    address[item] = this.fields.customShippingAddress[item].value ? this.fields.customShippingAddress[item].value : null;
                });

                return address;
            },
            // noPickupCustomer() {
            //   // added 3/20/2020 to display to specific customer list that order pick-up is unavailable
            //   // please remove this and fetchCart/fetchCartRes when this no longer applies

            //   const customers = [
            //     '12520',
            //     'PD100129',
            //     'PD100243',
            //     'PD101193',
            //     'PD101820',
            //     'PD102505',
            //     'PD104634',
            //     'PD107753',
            //     'PD111297',
            //     'PD110327',
            //     'PD111178',
            //     'PD110620',
            //     'PD117633',
            //     'PD117037',
            //     'PD117693',
            //     'PD120450',
            //     'PD120609',
            //     'PD119882',
            //     'PD120090',
            //     'PD122759',
            //     'PD123922',
            //     'PD130307',
            //     'PD123526',
            //     'PD131440',
            //     'PD131443',
            //     'PD131871',
            //     'PD134010',
            //     'PD135348',
            //     'PD135499',
            //     'PD136068',
            //     'PD136257',
            //     'PD134945',
            //     'PD136531',
            //     'PD164876',
            //     'PD164687',
            //     'PD169664',
            //     'PD173934',
            //     'PD190511',
            //     'PD190797',
            //     'PD191002',
            //     'PD110143',
            //     'PD111641',
            //     'PD115363',
            //     'PD116691',
            //     'PD117283',
            //     'PD119275',
            //     'PD135835',
            //     'PD136067',
            //     'PD136115',
            //     'PD136530',
            //     'PD168811',
            //     'PD174435',
            //     'PD191224',
            //     'PD191223',
            //     'PD143529',
            //     'PD143739',
            //     'PD145116',
            //     'PD145168',
            //     'PD147127',
            //     'PD143285',
            //     'PD143531',
            //     'PD143552',
            //     'PD143567',
            //     'PD145740',
            //     'PD145761',
            //     'PD143255',
            //     'PD146256',
            //     'PD145495',
            //     'PD147968',
            //     'PD147799',
            //     'PD154981',
            //     'PD151986',
            //     'PD152737',
            //     'PD189001',
            //     'PD143608',
            //     'PD145490',
            //     'PD145871',
            //     'PD150070',
            //     'PD150351',
            //     'PD151955',
            //     'PD154996',
            //     'PD196043',
            //     'PD196205',
            //     'PD196206',
            //     'PD197847',
            //     'PD198467',
            //     'PD198472',
            //     'PD198470',
            //     'PD198555',
            //     'PD198705',
            //     'PD198978',
            //   ]

            //   if (customers.indexOf(this.fetchCartRes.CustomerNumber) >= 0) {
            //     return true
            //   }
            //   return false
            // },
        },
        methods: {
            async setValues() {
                // needed for no pick-up customer messaging from 3/20/2020
                // please remove this and fetchCart/fetchCartRes when this no longer applies
                this.fetchCartRes = await fetchCartSummary();
                // end of 3/20 update

                const shippingRes = await getShippingBilling();

                if (shippingRes.status != 200) {
                    this.HasError = true;
                    console.log('From Shipping Billing JS File', shippingRes.message);
                    this.isLoading = false;
                    swal('Notice', shippingRes.message, 'info');
                    return;
                }

                this.res = shippingRes;

                // function to set non-default values, if there are any
                const setCustomAddress = function (resObj, fieldObj) {
                    Object.keys(resObj).forEach((key) => {
                        if (fieldObj[key] && resObj[key]) {
                            fieldObj[key].value = resObj[key];
                        }
                    });
                };

                // set default shipvias
                this.shipVia.default = shippingRes.defaultCustomerAddress.ShipVias;

                // set current shipping address
                if (shippingRes.CurrentShippingAddress.Id === null) {
                    this.fields.shipType = 'Default';
                    this.shipAddressIsDefault = true;

                    // set shipvias
                    shippingRes.ShipVias.forEach((item) => {
                        if (item.Selected) {
                            this.fields.shipVia.default.value = item.Description;
                        }
                    });
                } else {
                    this.fields.shipType = 'New Address';
                    this.shipAddressIsDefault = false;
                    this.shipVia.validated = true;
                    this.shipVia.showCustomShipVias = true;
                    setCustomAddress(shippingRes.CurrentShippingAddress, this.fields.customShippingAddress);

                    // set shipvias
                    this.shipVia.custom = shippingRes.ShipVias;
                    shippingRes.ShipVias.forEach((item) => {
                        if (item.Selected) {
                            this.fields.shipVia.custom.value = item.Description;
                        }
                    });

                    // add 'please select' to default ship vias, in case customer switches shipping to default
                    this.shipVia.default.unshift({
                        Description: 'Please Select',
                    });
                    this.fields.shipVia.default.value = 'Please Select';
                }

                // set billing type
                this.fields.billingType = 'Account';

                if (shippingRes.AccountTypes.length > 1) {
                    // no saved credit card info in api, so will always default to 'account' on pageload
                    // if more than one billing type, display credit card option
                    this.hasMultiplePaymentTypes = true;
                    this.fields.billingType = 'Account';
                } else {
                    // customer can only pay via credit card
                    this.hasMultiplePaymentTypes = false;
                    this.fields.billingType = 'CreditCard';
                }

                // set custom billing address, if necessary
                if (!this.billingAddressIsDefault) {
                    setCustomAddress(shippingRes.CurrentBillingAddress, this.fields.customBillingAddress);
                }

                this.isLoading = false;
            },
            async openShipVias() {
                // make sure not shipping to a po box
                if (this.fields.customShippingAddress.StreetLine1.value.toLowerCase().indexOf('po box') >= 0 && !this.res.AllowPOBox) {
                    this.addressValidation.showPOBoxError = true;
                    return;
                }

                // make sure fields are filled
                const filled = this.isSectionFilled(this.fields.customShippingAddress);
                if (!filled) {
                    return;
                }

                this.isLoading = true;
                const res = await validateAddress(this.addressValidationValues);
                this.isLoading = false;

                if (res.ShipVias) {
                    this.shipVia.custom = res.ShipVias;
                    this.shipVia.custom.unshift({
                        Description: 'Please Select',
                    });
                    this.fields.shipVia.custom.value = 'Please Select';
                }

                if (res.IsDifferent) {
                    // if there's an address suggestion, show popup to approve suggested address
                    this.addressValidation.suggestedAddress = res.Addresses[0];
                    this.addressValidation.showSuggestion = true;
                    return;
                } else if (res.IsFailed) {
                    // no suggestion found, show error message
                    this.addressValidation.showFailureToValidate = true;
                    return;
                }

                if (!res.IsDifferent && !res.IsFailed) {
                    // if original address is totally correct
                    // reassign suggested address to make sure everything is UPS-approved
                    this.applySuggestedAddress(res.Addresses[0]);
                    this.shipVia.showCustomShipVias = true;
                }
            },
            hideShipVias() {
                this.shipVia.showCustomShipVias = false;
                this.fields.shipVia.custom.value = '';
            },
            applySuggestedAddress(newAddress) {
                Object.keys(newAddress).forEach((item) => {
                    if (!newAddress[item]) {
                        return;
                    }
                    this.fields.customShippingAddress[item].value = newAddress[item];
                });
            },
            async keepOriginalAddress() {
                // get default residential shipping vias
                const res = await API.address.shippingVia(false);

                if (res.error) {
                    this.submissionError.exists = true;
                    this.submissionError.text =
                        'An error has occurred. Please refresh your page and try again. If issue persists, contact Customer Service at 1-800-527-4007.';
                    return;
                }

                this.shipVia.custom = res;
                this.shipVia.custom.unshift({
                    Description: 'Please Select',
                });
                this.fields.shipVia.custom.value = 'Please Select';
                this.shipVia.showCustomShipVias = true;
                this.addressValidation.showSuggestion = false;
            },
            useSuggestedAddress() {
                this.addressValidation.showSuggestion = false;
                this.applySuggestedAddress(this.addressValidation.suggestedAddress);
                this.openShipVias();
            },
            isSectionFilled(obj) {
                let filled = true;
                // reusable function to check whether Vue data object fields are blank
                Object.keys(obj).forEach((key) => {
                    // check if required field
                    if (obj[key].filled !== undefined) {
                        // check if value exists
                        if (obj[key].value.replace(/\s+/g, '').length) {
                            obj[key].filled = true;
                        } else if (key == 'Phone') {
                            if (!this.fetchCartRes.Freight.IsLTL && !this.res.shippingAddressIsDefault) {
                                obj[key].filled = true;
                            } else {
                                obj[key].filled = false;
                                filled = false;
                            }
                        } else {
                            obj[key].filled = false;
                            filled = false;
                        }
                    }
                });
                return filled;
            },
            isFormFilled() {
                let filled = true;

                // check if shipping address fields are empty, if necessary
                if (!this.shipAddressIsDefault) {
                    const shipAddressFilled = this.isSectionFilled(this.fields.customShippingAddress);
                    if (!shipAddressFilled) {
                        filled = false;
                    }
                }

                // check if shipvia filled
                const checkShipVias = function (target) {
                    if (!target.value.length || target.value === 'Please Select') {
                        target.filled = false;
                        return false;
                    }
                    target.filled = true;
                    return true;
                };

                let isShipViaFilled;
                if (this.shipAddressIsDefault) {
                    isShipViaFilled = checkShipVias(this.fields.shipVia.default);
                } else {
                    isShipViaFilled = checkShipVias(this.fields.shipVia.custom);
                }
                if (!isShipViaFilled) {
                    filled = false;
                }

                // check if billing address fields are empty, if necessary
                if (!this.billingAddressIsDefault && this.fields.billingType === 'CreditCard') {
                    const billAddressfilled = this.isSectionFilled(this.fields.customBillingAddress);
                    if (!billAddressfilled) {
                        filled = false;
                    }
                }

                // check if credit card fields is empty, if necessary
                if (this.fields.billingType === 'CreditCard') {
                    const creditCardfilled = this.isSectionFilled(this.fields.creditCard);
                    if (!creditCardfilled) {
                        filled = false;
                    }
                }

                return filled;
            },
            selectUnvalidatedAddress() {
                this.addressValidation.showFailureToValidate = false;
                this.shipVia.showCustomShipVias = true;
            },
            async submitForm(e) {
                e.preventDefault();

                // check whether necessary fields are filled out
                const filled = this.isFormFilled();
                if (!filled) {
                    return;
                }

                // check if custom shipping address is valid, if necessary

                this.post();
            },
            async post() {
                const res = await postShippingBilling(this.postValues);

                if (res.status !== 200) {
                    this.submissionError.exists = true;
                    if (res.Message) {
                        this.submissionError.text = res.Message;
                    } else {
                        this.submissionError.text = 'An error has occurred. If issue persists, please contact Customer Service at 1-800-527-4007.';
                    }
                    return;
                }

                window.location = document.getElementById('submit-button').getAttribute('href');
            },
        },
        mounted() {
            this.setValues();
        },
    });
}

function init() {}

export default init;
